"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDiversity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_i18next_1 = require("react-i18next");
function ChangeDiversity() {
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { isMobile } = (0, device_1.usePlatform)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleClick = () => {
        var _a, _b, _c, _d;
        if (isOffline) {
            /**
             * @todo show snackbar from ca-modules
             */
            // @ts-ignore
            (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.Snackbar) === null || _b === void 0 ? void 0 : _b.showOfflineSnackbar(t('snackbar.offlineSkinLongpress'), null);
            return;
        }
        /**
         * @todo replace
         *
         * Hack for legacy code access
         */
        if (typeof ((_d = (_c = window.Manager) === null || _c === void 0 ? void 0 : _c.DiversityManager) === null || _d === void 0 ? void 0 : _d.openCYSOverlay) ===
            'function') {
            window.Manager.DiversityManager.openCYSOverlay(document.getElementById('react-root'));
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { role: "button", onClick: handleClick, "$disabled": isOffline, "$isMobile": isMobile, "data-e2e": 'ChangeDiversity_Container', children: [(0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Change_Diversity, width: 31, height: 26, "data-e2e": 'ChangeDiversity_Icon' }), (0, jsx_runtime_1.jsx)(ChangeDiversityLabel, { "data-e2e": 'ChangeDiversity_ChangeDiversityLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.systemsMenu.changeSkin) })] }));
}
exports.ChangeDiversity = ChangeDiversity;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 4px;
  cursor: pointer;
  color: ${({ theme }) => theme.disabledSecondary};
  margin-bottom: ${({ $isMobile }) => ($isMobile ? 15 : 0)}px;

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      opacity: 0.3;
    `}
`;
const ChangeDiversityLabel = styled_components_1.default.div `
  padding: 8px 0;
  text-align: center;
  font-size: 10px;
`;
